import { resolveCampImage, resolveCampMobileImage } from "./campImageMap";

/**
 * Full-bleed hero strip (`ul` > `li` > `img`).
 * Pass `imageName` = file basename in `src/assets/images` (png, jpg, webp, gif, svg).
 * Example: `image_02` → `image_02.jpg`. Optional mobile: `uud_2_m.png` for `imageName="uud_2"`.
 */
export default function CampHeroMedia({
  imageName = "uud_2",
  imageAlt = "デザインプロセス解説ビジュアル",
  imageBgColor = "#15a6f8",
  /** `(max-width: …)` at which the `_m` asset is chosen when present */
  mobileImageMaxWidth = "768px",
} = {}) {
  const imageSrc = resolveCampImage(imageName);
  if (!imageSrc) return null;

  const mobileSrc = resolveCampMobileImage(imageName);

  const img = (
    <img
      className="event-temp-event-header__hero-img"
      src={imageSrc}
      alt={imageAlt}
      decoding="async"
    />
  );

  return (
    <ul className="event-temp-event-header__media-list">
      <li
        className="event-temp-event-header__media-item"
        style={{ backgroundColor: imageBgColor }}
      >
        {mobileSrc ? (
          <picture>
            <source media={`(max-width: ${mobileImageMaxWidth})`} srcSet={mobileSrc} />
            {img}
          </picture>
        ) : (
          img
        )}
      </li>
    </ul>
  );
}
